import { createAction } from '@reduxjs/toolkit';
import { tagSlice } from './reducer';

export const { recieveTag, recieveCoupons, recieveSimilar, recieveAlsoLike } = tagSlice.actions;

export const fetchTagData = createAction('tag/fetchTag');
export const fetchTagSimilar = createAction('tag/fetchTagSimilar');
export const fetchTagAlsoLike = createAction('tag/fetchTagAlsoLike');
